import Vue from 'vue'
import { Button } from 'element-ui'
import { Collapse } from 'element-ui'
import { CollapseItem } from 'element-ui'
import { DatePicker } from 'element-ui'
import { Tree } from 'element-ui'
import { Select } from 'element-ui'
import { Option } from 'element-ui'
import { Row } from 'element-ui'
import { Col } from 'element-ui'
import { Table } from 'element-ui'
import { TableColumn } from 'element-ui'
import { Input } from 'element-ui'
import { Card } from 'element-ui'
import '../element-variables.scss'

Vue.use(Button)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatePicker)
Vue.use(Tree)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Card)